import React from "react";

const industries = [
  "Fashion and apparel",
  "Beauty and cosmetics",
  "Electronics",
  "Furniture",
  "Home décor",
  "Healthcare",
  "Automotive",
  "Food and beverage",
  "Industrial suppliers",
  "B2B ecommerce",
];

export default function Section3() {
  return (
    <div className="w-full Section3 px-5 md:px-0 pt-[4%]">
      <div className="flex flex-col items-center w-full md:flex-row justify-evenly section3-container gap-y-8">
        <div className="w-full md:w-[42%] text-[#373737]">
          <h2 className="text-[26px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#DA2128] my-[0.67em] pb-[2%]">
            Enterprise Shopify Plus Development for Growing Businesses
          </h2>
          <p className="leading-[22px] pb-[1%] text-sm md:text-base mb-5 font-open">
            As your business grows, your ecommerce platform needs to keep up.
            More visitors mean more products. More orders and sales channels
            need a stronger foundation.
          </p>
          <p className="leading-[22px] pb-[1%] text-sm md:text-base mb-5 font-open">
            Our Shopify Plus developers build ecommerce solutions for big
            businesses. These solutions help them grow. They grow with
            confidence. We build stores for speed, stability, and
            flexibility. We also make sure the shopping experience is simple
            for customers.
          </p>
          <p className="leading-[22px] pb-[1%] text-sm md:text-base mb-5 font-open">
            We have the right Shopify Plus development services for you. It
            does not matter if you sell to consumers, run a wholesale
            business, or manage several brands. Our services are tailored to
            your specific needs.
          </p>
        </div>

        <div className="w-full md:w-[46%]">
          <img
            src="/assets/Enterprise Shopify Plus Development for Growing Businesses.webp"
            alt="Enterprise Shopify Plus Development for Growing Businesses"
            className="w-full h-auto mb-6"
          />
          <p className="leading-[22px] text-sm md:text-base mb-3 font-open text-[#151515]">
            Our team works with businesses across different industries,
            including:
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-2 gap-3">
            {industries.map((item) => (
              <div
                key={item}
                className="bg-[#F5F5F5] text-[#373737] rounded-[6px] px-4 py-3 text-xs md:text-sm font-open flex items-center gap-2 border-l-[3px] border-[#DA2128]"
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}